import { useMemo } from 'react'
import styled from '@emotion/styled'
import Chip from '@mui/material/Chip'
import { arrayOf, string, func, object } from 'prop-types'
import { CvsTextField } from '@components'

const FlexRow = styled.div`
  display: flex;
  flex-direction: column;
`

const ChipMargin = styled(Chip)`
  margin-right: 4px;
`

export const CvsChipBuilderInput = ({
  options = arrayOf(object),
  onChange = () => {},
  value = '',
  ...rest
}) => {
  const opts = useMemo(
    () =>
      options.reduce(
        (acc, opt) => ({
          ...acc,
          [opt.id]: opt.label,
        }),
        {},
      ),
    [options],
  )

  return (
    <FlexRow>
      <div>
        <CvsTextField fullWidth value={value} onChange={e => onChange(e.target.value)} {...rest} />
      </div>
      <div>
        {options.map(o => (
          <ChipMargin label={opts[o.id]} key={o.id} onClick={() => onChange(value + o.id)} />
        ))}
      </div>
    </FlexRow>
  )
}

CvsChipBuilderInput.propTypes = {
  value: string,
  onChange: func,
  options: arrayOf(object),
}
